import React from "react";

import Link from "../Link";
import ExternalLink from "../ExternalLink";

import {
  Container,
  CardImage,
  CardInfoContainer,
  CardTitle,
  CardDescription,
  AdditionalMessage,
} from "./styles";

export interface TabCardV2Props {
  imageSrc?: string;
  iconComponent?: React.ReactNode;
  title: string;
  description: string;
  height?: string;
  soon?: boolean;
  link?: string;
  isExternalLink?: boolean;
  hideTextOnSmallMobile?: boolean;
  layoutOnMobile?: 'column' | 'row';
}

function TabCard({ imageSrc, iconComponent, title, description, height, soon, link, isExternalLink = false, hideTextOnSmallMobile = false, layoutOnMobile = 'row' }: TabCardV2Props) {
  const IconComponent = iconComponent;

  const renderCardText = () => {
    return (
      <>
        <CardTitle hideTextOnSmallMobile={hideTextOnSmallMobile}>
          {title}
          {soon && (
            <AdditionalMessage>
              <span>SOON</span>
            </AdditionalMessage>
          )}
        </CardTitle>
        <CardDescription hideTextOnSmallMobile={hideTextOnSmallMobile}>{description}</CardDescription>
      </>
    )
  };

  const renderExternalLink = () => {
    return (
      <ExternalLink href={link} target="_blank" rel="noopener noreferrer">
        {renderCardText()}
      </ExternalLink>
    );
  };

  const renderInternalLink = () => {
    return (
       <Link to={link}>
        {renderCardText()}
      </Link>
    );
  };

  return (
    <Container height={height} hideTextOnSmallMobile={hideTextOnSmallMobile} layoutOnMobile={layoutOnMobile}>
      <CardImage>
        {IconComponent && <IconComponent/>}
        {imageSrc && <img src={imageSrc} alt="card_image" />}
      </CardImage>
      <CardInfoContainer hideTextOnSmallMobile={hideTextOnSmallMobile}>
        {link ? ( 
          isExternalLink ? renderExternalLink() : renderInternalLink()
        ) : (
          renderCardText()
        )}  
      </CardInfoContainer>
      </Container>
  );
}

export default TabCard;
